/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flyergenerate1Inputs */

const en_flyergenerate1 = /** @type {(inputs: Flyergenerate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate flyer`)
};

const de_flyergenerate1 = /** @type {(inputs: Flyergenerate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flyer erstellen`)
};

/**
* | output |
* | --- |
* | "Generate flyer" |
*
* @param {Flyergenerate1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const flyergenerate1 = /** @type {((inputs?: Flyergenerate1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flyergenerate1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flyergenerate1(inputs)
	return de_flyergenerate1(inputs)
});
export { flyergenerate1 as "flyerGenerate" }